exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-1ae0c674] {\n  margin-left: 0 !important;\n  white-space: nowrap;\n}", ""]);

// exports
